﻿<!-- TODO: no Title? -->

<mat-dialog-content>
    <details [color]="color" [detailUrl]="detailUrl" [model]="model">
    </details>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <ng-container *ngFor="let action of cardActions">
        <button mat-button (click)="close(action)" [matTooltip]="action.label" class="noMinWidth" [attr.aria-label]="action.label" [attr.telemetry]="action.label">
            <mat-icon [ngStyle]="getActionStyle(action)">
                {{action.icon}}
            </mat-icon>
        </button>
    </ng-container>

    <button mat-button mat-dialog-close telemetry="Submission-DetailClose">
        Close
    </button>
</mat-dialog-actions>